module.exports = __webpack_public_path__ + "static/media/Rayovac-Radio.10ae3d37.jpg";